import api from "./client";

export const stressTestsAPI = {
  createStressTest: async (payload, clientId) => {
    const response = await api.post("/api/v1/stress_tests", payload, {
      params: { client_id: clientId },
    });
    return response;
  },

  getStressTest: async (id, clientId) => {
    const response = await api.get(`/api/v1/stress_tests/${id}`, {
      params: { client_id: clientId },
    });
    return response;
  },

  // Stop a running stress test (QA-8.5). Drains in-flight calls; the response
  // carries the same { stress_test, report } shape as show, now partial.
  abortStressTest: async (id, clientId) => {
    const response = await api.post(`/api/v1/stress_tests/${id}/abort`, null, {
      params: { client_id: clientId },
    });
    return response;
  },

  // Collection route (no :id — nothing is persisted yet) — matches
  // config/routes.rb's `get :quote` under stress_tests' collection block.
  getQuote: async (params, clientId) => {
    const response = await api.get("/api/v1/stress_tests/quote", {
      params: { ...params, client_id: clientId },
    });
    return response;
  },
};
